<template>
  <div :id="domId" class="xl_login">
    <img v-if="inXL" src="~/assets/pic/login_bg.png" @click="showDialog" />
  </div>
</template>

<script>
import { isGoToLoginLink } from '~/utils/util'
export default {
  props: {
    domId: {
      type: String,
      default: 'xl_login'
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      inXL: false
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.inXL = xlQuickLogin.isTbcClient()
      // const config = {
      //   LOGIN_ID: 22035,
      //   APP_NAME: 'wan.xunlei.com',
      //   UI_THEME: 'default',
      //   REGISTER_TYPES: ['mobile'],
      //   THIRD_LOGIN_DISPLAY: true,
      //   LOGIN_TYPES: ['account', 'mobile'],
      //   LOGIN_SUCCESS_FUNC: () => {
      //     location.reload()
      //   },
      //   LOGOUT_FUNC: () => {
      //     location.reload()
      //   }
      // }
      // if (this.inXL) {
      //   config.UI_TYPE = 'popup'
      //   config.CLIENT_FEATURE = true
      // } else {
      //   config.UI_STYLE = 'https://wan.xunlei.com/css/login.css'
      // }
      // xlQuickLogin.init(config)
      if (this.inXL) {
        if (this.type === 'popup') {
          this.showDialog()
        }
        this.$store.commit('app/setLoginPop', false)
      } else if (!xlQuickLogin.isLogined()) {
        // 判断是否已登录
        // 判断是否跳转到登陆页
        const localUrl = location.href
        const isLoginPage = location.href.includes('wan.xunlei.com/login')
        if (isGoToLoginLink() && !isLoginPage) {
          const redirectUrl =
            'https://wan.xunlei.com/login?redirect_uri=' +
            encodeURIComponent(localUrl)
          location.replace(redirectUrl)
          return
        }
        xlQuickLogin.getLoginIframe(this.domId) // 将登录iframe放入业务自己的页面中，参数可以是元素id或dom，这里假设放入业务的一个id为xl_login的元素中
        this.$emit('show')
      }
    },
    showDialog() {
      xlQuickLogin.popup()
    }
  }
}
</script>
